import BaseLink from './components/UI/BaseLink.vue';
import BaseCard from './components/UI/BaseCard.vue';
import BaseButton from './components/UI/BaseButton.vue';
import BaseBadge from './components/UI/BaseBadge.vue';
import BaseInput from './components/UI/BaseInput.vue';
import BaseFilter from './components/UI/BaseFilter.vue';
import BaseSpinner from './components/UI/BaseSpinner.vue';
import BaseModal from './components/UI/BaseModal.vue';

const BaseComponents = [
    { name: 'base-link', component: BaseLink },
    { name: 'base-card', component: BaseCard },
    { name: 'base-button', component: BaseButton },
    { name: 'base-badge', component: BaseBadge },
    { name: 'base-input', component: BaseInput },
    { name: 'base-filter', component: BaseFilter },
    { name: 'base-spinner', component: BaseSpinner },
    { name: 'base-modal', component: BaseModal },
]

export default BaseComponents;